import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { useLingui } from '@lingui/react/macro'

export const Duration = ({ duration }: { duration: number }) => {
	const { t } = useLingui()

	return (
		<>
			{duration === 30
				? t`1/2h`
				: dateTimeUtils
						.duration(duration, 'minutes')
						.format('H[h]mm')
						.replace('h00', 'h')}
		</>
	)
}
